export default __webpack_public_path__ + "cover.6cab8e17501d189c64c96cb9cf1b73eb.jpg"